import {Endpoint} from '@eryxcoop/appyx-comm';

export default class CreateOrderEndpoint extends Endpoint {

  adaptValues(order) {
    return {
      ...order,
      "sales_point": "MARKETPLACE"
    }
  }
}